import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { history } from '../store'
import { push } from 'react-router-redux'
import AppBaqueiraHeader from '../containers/AppBaqueiraHeader'
import { withNamespaces } from "react-i18next"
import { fetchDisponibility, fetchAvailability } from '../actions/qrsbaqueira'
import StepBarBaqueira from '../components/StepBarBaqueira'
import { fetchCalendarByOperator } from '../actions/calendars'
import { format } from 'date-fns'
import { fromZonedTime } from 'date-fns-tz'
import { Grid2x2Check, Info, ChevronLeft } from 'lucide-react'
import { currencySymbol } from '../utils/currency';

const TZ = 'Europe/Madrid'

function madrid1500ToUtc(dateObj) {
  const ymd = format(dateObj, 'yyyy-MM-dd')
  return fromZonedTime(`${ymd} 15:00:00`, TZ)
}

function applyBusinessRules(totalAmount, daysSelected, businessRules) {
  const activeRules = businessRules.filter(r => r.Active && r.Type === 'MaxDayDiscount')
  if (!activeRules.length) return { total: totalAmount, applied: null }
  activeRules.sort((a, b) => b.MaxDays - a.MaxDays)
  const matchingRule = activeRules.find(r => daysSelected >= r.MaxDays)
  if (matchingRule) {
    return { total: totalAmount * (1 - matchingRule.DiscountPercentage / 100), applied: matchingRule }
  }
  return { total: totalAmount, applied: null }
}

const ORDERED_LOCKER_KEYS = [
  'BNS', 'CNS', 'BWS', 'CWS',
  'BNM', 'CNM', 'BWM', 'CWM',
  'BNL', 'CNL', 'BWL', 'CWL',
  'BNXL', 'CNXL', 'BWXL', 'CWXL',
  'BN2XL', 'CN2XL', 'BW2XL', 'CW2XL',
  'BN3XL', 'CN3XL', 'BW3XL', 'CW3XL',
]

class LockerSelectorBaqueiraView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lockers: null,
      prices: null,
      selectedLockerType: null,
      selectedQuantity: 1,
      startDate: null,
      endDate: null,
      selectedInfo: null,
      qrType: 'pay',
      errorMessage: false,
      isDurationExceeded: false,
      priceCalendar: {},
      calendarMonth: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      limitDays: 30,
      selectedPrices: [],
      totalAmount: 0,
      isTypeModalOpen: false,
      isQtyModalOpen: false,
      isDatesModalOpen: false,
      isLoading: false,
      activePanel: 'type',
      businessRules: [],
      appliedRule: null,
      panelLeft: 0,
      measureModal: false,
      measureType: null,
    }

    this.formRef = React.createRef()
    this.typeBtnRef = React.createRef()
    this.qtyBtnRef = React.createRef()
    this.datesStartBtnRef = React.createRef()

    this.handleQuantityChange = this.handleQuantityChange.bind(this)
    this.handleStartDateChange = this.handleStartDateChange.bind(this)
    this.handleEndDateChange = this.handleEndDateChange.bind(this)
    this.handleContinue = this.handleContinue.bind(this)
  }

  openModal = (key) => this.setState({ [key]: true })
  closeModal = (key) => this.setState({ [key]: false })

  openPanel = (panel) => {
    let btnRef = null
    if (panel === 'type') btnRef = this.typeBtnRef
    if (panel === 'qty') btnRef = this.qtyBtnRef
    if (panel === 'dates') btnRef = this.datesStartBtnRef

    if (btnRef?.current && this.formRef?.current) {
      const btnRect = btnRef.current.getBoundingClientRect()
      const formRect = this.formRef.current.getBoundingClientRect()
      this.setState({ activePanel: panel, panelLeft: btnRect.left - formRect.left })
    } else {
      this.setState({ activePanel: panel, panelLeft: 0 })
    }
  }
  closePanel = () => this.setState({ activePanel: null })

  componentDidMount() {
    const { zoneSelected, qr } = this.props.location.state
    const qrtoken = qr.toString() + zoneSelected.toString()

    this.props.fetchAvailability(qrtoken)
      .then((answer) => {
        const answerLockers = answer.response.answerLockers
        this.setState(
          { lockers: answerLockers.Disponibility, prices: answerLockers.Prices, qrType: answerLockers.qrType, isTypeModalOpen: true },
          () => { setTimeout(() => { if (this.typeBtnRef?.current) this.openPanel('type') }, 0) }
        )
      })
      .catch(console.error)
  }

  selectLockerType(lockerType) {
    const lockerPrice = this.getLockerPrice(lockerType)
    const { zoneSelected, descriptionZone } = this.props.location.state

    this.setState({
      selectedLockerType: lockerType,
      selectedInfo: { lockerType, lockerPrice, zoneSelected, descriptionZone },
      priceCalendar: {},
      startDate: null,
      endDate: null,
      selectedPrices: [],
      totalAmount: 0,
    })

    this.props.fetchCalendarByOperator('66ed5789f181bef9df55042c', lockerType, zoneSelected)
      .then((response) => {
        const calendarArray = response?.response?.PriceCalendar || []
        const rulesFromOperator = (response?.response?.BusinessRules || []).filter(r => r && r.Active)

        const flatPriceMap = {}
        calendarArray.forEach(entry => {
          const d = new Date(entry.date)
          const isoDate = d.toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
          const matchedPrice = entry.prices.find(p => p.zone === zoneSelected && p.type === lockerType)
          if (matchedPrice) flatPriceMap[isoDate] = matchedPrice.price
        })

        this.setState({ priceCalendar: flatPriceMap, businessRules: rulesFromOperator })
      })
      .catch(console.error)
  }

  renderMonthGrid(monthDate) {
    const { priceCalendar, startDate, endDate, calendarMonth, selectedQuantity } = this.state
    const { t } = this.props

    const year = monthDate.getFullYear()
    const month = monthDate.getMonth()
    const firstDay = new Date(year, month, 1)
    const lastDay = new Date(year, month + 1, 0)
    const daysInMonth = lastDay.getDate()
    const blanks = Array(firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1).fill(null)

    const weekDays = [t('Lun'), t('Mar'), t('Mie'), t('Jue'), t('Vie'), t('Sab'), t('Dom')]
    const title = firstDay.toLocaleString('default', { month: 'long', year: 'numeric' })

    const days = []
    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month, d)
      const iso = date.toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
      const price = priceCalendar[iso]

      const isStart = startDate && date.toDateString() === startDate.toDateString()
      const isEnd = endDate && date.toDateString() === endDate.toDateString()
      const inRange = startDate && endDate && date > startDate && date < endDate
      const isPast = this.isBeforeToday(date)
      const isTodayAndBlocked = this.isToday(date) && this.isTodayBlocked()
      const isSingleDay = isStart && isEnd && startDate?.toDateString() === endDate?.toDateString()

      let cls = 'bq-ls-cal-cell'
      if (isSingleDay) cls += ' selected single'
      else {
        if (isStart) cls += ' selected start'
        if (isEnd) cls += ' selected end'
        if (inRange) cls += ' in-range'
      }
      if (isPast || !price || isTodayAndBlocked) cls += ' disable'

      days.push(
        <div
          key={iso}
          className={cls}
          onClick={() => { if (!isPast && price && !isTodayAndBlocked) this.handleCalendarDateClick(new Date(date)) }}
          title={price ? `${t('Precio')}: ${(price * selectedQuantity).toFixed(2)} ${currencySymbol()}` : t('Sin precio')}
        >
          <div className="day">{d}</div>
          <div className="price">{price && !isPast ? `${parseFloat((price * selectedQuantity).toFixed(2))} ${currencySymbol()}` : '-'}</div>
        </div>
      )
    }

    return (
      <div className="bq-ls-cal-month-grid">
        <div className="bq-ls-cal-header">
          <button
            className="bq-ls-cal-nav"
            disabled={this.isCurrentMonthOrBefore(calendarMonth)}
            onClick={() => {
              if (!this.isCurrentMonthOrBefore(calendarMonth)) {
                this.setState({ calendarMonth: new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() - 1, 1) })
              }
            }}
          >
            &lt;
          </button>
          <h6 className="bq-ls-cal-month">{title.charAt(0).toUpperCase() + title.slice(1)}</h6>
          <button
            className="bq-ls-cal-nav"
            onClick={() => this.setState({ calendarMonth: new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 1) })}
          >
            &gt;
          </button>
        </div>
        <div className="bq-ls-cal-grid">
          {weekDays.map(day => <div key={day} className="bq-ls-cal-cell weekday-header">{day}</div>)}
          {blanks.map((_, i) => <div key={`blank-${i}`} className="bq-ls-cal-cell empty" />)}
          {days}
        </div>
      </div>
    )
  }

  renderMonthGridPC(monthDate, isFirstMonth) {
    const { priceCalendar, startDate, endDate, calendarMonth, selectedQuantity } = this.state
    const { t } = this.props

    const year = monthDate.getFullYear()
    const month = monthDate.getMonth()
    const firstDay = new Date(year, month, 1)
    const lastDay = new Date(year, month + 1, 0)
    const daysInMonth = lastDay.getDate()
    const blanks = Array(firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1).fill(null)

    const weekDays = [t('Lun'), t('Mar'), t('Mie'), t('Jue'), t('Vie'), t('Sab'), t('Dom')]
    const title = firstDay.toLocaleString('default', { month: 'long', year: 'numeric' })

    const days = []
    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month, d)
      const iso = date.toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
      const price = priceCalendar[iso]

      const isStart = startDate && date.toDateString() === startDate.toDateString()
      const isEnd = endDate && date.toDateString() === endDate.toDateString()
      const inRange = startDate && endDate && date > startDate && date < endDate
      const isPast = this.isBeforeToday(date)
      const isTodayAndBlocked = this.isToday(date) && this.isTodayBlocked()
      const isSingleDay = isStart && isEnd && startDate?.toDateString() === endDate?.toDateString()

      let cls = 'bq-ls-cal-cell'
      if (isSingleDay) cls += ' selected single'
      else {
        if (isStart) cls += ' selected start'
        if (isEnd) cls += ' selected end'
        if (inRange) cls += ' in-range'
      }
      if (isPast || !price || isTodayAndBlocked) cls += ' disable'

      days.push(
        <div
          key={iso}
          className={cls}
          onClick={() => { if (!isPast && price && !isTodayAndBlocked) this.handleCalendarDateClick(new Date(date)) }}
          title={price ? `${t('Precio')}: ${(price * selectedQuantity).toFixed(2)} ${currencySymbol()}` : t('Sin precio')}
        >
          <div className="day">{d}</div>
          <div className="price">{price ? `${parseFloat((price * selectedQuantity).toFixed(2))} ${currencySymbol()}` : '-'}</div>
        </div>
      )
    }

    return (
      <div className="bq-ls-cal-month-grid">
        <div className="bq-ls-cal-header">
          {isFirstMonth ? (
            <>
              <button
                className="bq-ls-cal-nav"
                disabled={this.isCurrentMonthOrBefore(calendarMonth)}
                onClick={() => {
                  if (!this.isCurrentMonthOrBefore(calendarMonth)) {
                    this.setState({ calendarMonth: new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() - 1, 1) })
                  }
                }}
              >
                &lt;
              </button>
              <h6 className="bq-ls-cal-month">{title.charAt(0).toUpperCase() + title.slice(1)}</h6>
            </>
          ) : (
            <>
              <h6 className="bq-ls-cal-month">{title.charAt(0).toUpperCase() + title.slice(1)}</h6>
              <button
                className="bq-ls-cal-nav"
                onClick={() => this.setState({ calendarMonth: new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 1) })}
              >
                &gt;
              </button>
            </>
          )}
        </div>
        <div className="bq-ls-cal-grid">
          {weekDays.map(day => <div key={day} className="bq-ls-cal-cell weekday-header">{day}</div>)}
          {blanks.map((_, i) => <div key={`blank-${i}`} className="bq-ls-cal-cell empty" />)}
          {days}
        </div>
      </div>
    )
  }

  renderPriceCalendar() {
    const { calendarMonth } = this.state
    return (
      <div className="bq-ls-cal-dual">
        {this.renderMonthGrid(calendarMonth)}
      </div>
    )
  }

  renderPriceCalendarPC() {
    const { calendarMonth } = this.state
    const nextMonth = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 1)
    return (
      <div className="bq-ls-cal-dual">
        {this.renderMonthGridPC(calendarMonth, true)}
        {this.renderMonthGridPC(nextMonth, false)}
      </div>
    )
  }

  handleCalendarDateClick = (clickedDate) => {
    const { startDate, endDate, priceCalendar, selectedQuantity } = this.state

    if (startDate && clickedDate.toDateString() === startDate.toDateString()) {
      this.setState({ startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false })
      return
    }

    if (!startDate || clickedDate < startDate) {
      const iso = clickedDate.toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
      const base = priceCalendar[iso] || 0
      const dayPrice = base * (selectedQuantity || 1)
      this.setState({
        startDate: clickedDate,
        endDate: clickedDate,
        isDurationExceeded: false,
        selectedPrices: base ? [{ date: new Date(clickedDate), price: dayPrice }] : [],
        totalAmount: base ? dayPrice : 0,
      })
      return
    }

    const diff = Math.ceil((clickedDate - startDate) / (1000 * 60 * 60 * 24))
    const tooLong = diff > this.state.limitDays

    if (!tooLong) {
      const selectedPrices = []
      let totalAmount = 0
      for (let d = new Date(startDate); d <= clickedDate; d.setDate(d.getDate() + 1)) {
        const iso = d.toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
        const price = priceCalendar[iso]
        if (price) {
          const dayPrice = price * selectedQuantity
          selectedPrices.push({ date: new Date(d), price: dayPrice })
          totalAmount += dayPrice
        }
      }
      const daysSelected = selectedPrices.length
      const { total, applied } = applyBusinessRules(totalAmount, daysSelected, this.state.businessRules)
      this.setState({ endDate: clickedDate, isDurationExceeded: false, selectedPrices, totalAmount: total, appliedRule: applied })
    } else {
      this.setState({ endDate: clickedDate, isDurationExceeded: true })
    }
  }

  handleQuantityChange(event) {
    this.setState({ selectedQuantity: event.target.value, startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false })
  }

  handleStartDateChange(date) {
    const { endDate } = this.state
    const localDate = new Date(date.setHours(15, 0, 0, 0))
    if (endDate) {
      const diff = Math.ceil((endDate - localDate) / (1000 * 60 * 60 * 24))
      this.setState({ startDate: localDate, isDurationExceeded: diff >= this.state.limitDays })
    } else {
      this.setState({ startDate: localDate })
    }
  }

  handleEndDateChange(date) {
    const { startDate } = this.state
    const localDate = new Date(date.setHours(15, 0, 0, 0))
    if (startDate) {
      const diff = Math.ceil((localDate - startDate) / (1000 * 60 * 60 * 24))
      this.setState({ endDate: localDate, isDurationExceeded: diff >= this.state.limitDays })
    } else {
      this.setState({ endDate: localDate })
    }
  }

  handleContinue() {
    if (this.state.isLoading) return
    this.setState({ isLoading: true, errorMessage: false })
    const { selectedLockerType, selectedQuantity, startDate, endDate, qrType, appliedRule } = this.state
    const { zoneSelected, descriptionZone, qr } = this.props.location.state

    const localStartDate = madrid1500ToUtc(this.state.startDate)
    const localEndDate = madrid1500ToUtc(this.state.endDate)
    const lockerQty = selectedQuantity == null ? 1 : Number(selectedQuantity)

    const bookingData = {
      Zone: zoneSelected,
      LockerType: selectedLockerType,
      LockerQty: lockerQty,
      RentalStartDate: localStartDate,
      RentalFinishDate: localEndDate,
      PaymentMethod: 'TPV',
    }

    this.props.fetchDisponibility(bookingData)
      .then((answer) => {
        if (answer.response.LockersDisponibility === true) {
          this.props.push('/PhoneBaqueiraView', {
            zoneSelected,
            descriptionZone,
            selectedLocker: selectedLockerType,
            lockerPrice: answer.response.LockersAmount,
            lockerAssigned: answer.response.LockersAssigned,
            prerentCode: answer.response.PrerentCode,
            prerentTime: answer.response.PrerentTime,
            totalDays: answer.response.TotalDays,
            startDate,
            endDate,
            qrType,
            qr,
            timeStamp: answer.response.TimeStamp,
            selectedQuantity,
            appliedRule,
          })
        } else {
          this.setState({ errorMessage: true, isLoading: false })
        }
      })
      .catch((error) => {
        console.error(error)
        this.setState({ isLoading: false })
      })
  }

  getLockerType(type) {
    const { t } = this.props
    switch (type) {
      case 'BNS':   return 'STANDARD'
      case 'CNS':   return 'STANDARD CARGA'
      case 'BWS':   return 'STANDARD XL'
      case 'CWS':   return 'STANDARD CARGA XL'
      case 'BNM':   return 'MEDIUM'
      case 'CNM':   return 'MEDIUM CARGA'
      case 'BWM':   return 'MEDIUM XL'
      case 'CWM':   return 'MEDIUM CARGA XL'
      case 'BNL':   return 'LARGE'
      case 'CNL':   return 'LARGE CARGA'
      case 'BWL':   return 'LARGE XL'
      case 'CWL':   return 'LARGE CARGA XL'
      case 'BNXL':  return 'LARGE'
      case 'CNXL':  return 'LARGE CARGA'
      case 'BWXL':  return 'LARGE XL'
      case 'CWXL':  return 'LARGE CARGA XL'
      case 'BN2XL': return 'LARGE'
      case 'CN2XL': return 'LARGE CARGA'
      case 'BW2XL': return 'LARGE XL'
      case 'CW2XL': return 'LARGE CARGA XL'
      case 'BN3XL': return t('2 Equipos de esquí')
      case 'CN3XL': return t('3 Equipos de esquí')
      case 'BW3XL': return t('4 Equipos de esquí')
      case 'CW3XL': return t('3 Equipos de esquí sin secado')
      default:      return 'STANDARD'
    }
  }

  getLockerPicture(type) {
    // Baqueira-exclusive ski lockers (3XL) have custom ski artwork; every other
    // type falls back to the standard measures artwork used by the normal selector view.
    const BAQUEIRA_SKI_IMAGES = ['BN3XL', 'CN3XL', 'BW3XL', 'CW3XL']
    return BAQUEIRA_SKI_IMAGES.includes(type)
      ? `/images/locker_baqueira_${type}.png`
      : `/images/measures/locker_final_${type}.png`
  }

  getLockerPrice(type) {
    const { prices } = this.state
    const obj = prices.find(p => p.item === `LOCKER${type}`)
    return obj ? Number(obj.price).toFixed(2) : '0.00'
  }

  getLockerDimensions(type) {
    const dims = {
      'BNS':   { ancho: 30, alto: 30,  fondo: 50 }, 'CNS':   { ancho: 30, alto: 30,  fondo: 50 },
      'BWS':   { ancho: 40, alto: 30,  fondo: 50 }, 'CWS':   { ancho: 40, alto: 30,  fondo: 50 },
      'BNM':   { ancho: 30, alto: 60,  fondo: 50 }, 'CNM':   { ancho: 30, alto: 60,  fondo: 50 },
      'BWM':   { ancho: 40, alto: 60,  fondo: 50 }, 'CWM':   { ancho: 40, alto: 60,  fondo: 50 },
      'BNL':   { ancho: 30, alto: 90,  fondo: 50 }, 'CNL':   { ancho: 30, alto: 90,  fondo: 50 },
      'BWL':   { ancho: 60, alto: 90,  fondo: 50 }, 'CWL':   { ancho: 60, alto: 90,  fondo: 50 },
      'BNXL':  { ancho: 30, alto: 120, fondo: 50 }, 'CNXL':  { ancho: 30, alto: 120, fondo: 50 },
      'BWXL':  { ancho: 40, alto: 120, fondo: 50 }, 'CWXL':  { ancho: 40, alto: 120, fondo: 50 },
      'BN2XL': { ancho: 30, alto: 150, fondo: 50 }, 'CN2XL': { ancho: 30, alto: 150, fondo: 50 },
      'BW2XL': { ancho: 40, alto: 150, fondo: 50 }, 'CW2XL': { ancho: 40, alto: 150, fondo: 50 },
      // Baqueira ski lockers — real measures provided by Baqueira (ancho × alto × fondo)
      'BN3XL': { ancho: 35, alto: 200, fondo: 50 }, // 2 equipos de esquí
      'CN3XL': { ancho: 36, alto: 218, fondo: 49 }, // 3 equipos de esquí
      'CW3XL': { ancho: 32, alto: 215, fondo: 44 }, // 3 equipos de esquí sin secado
      'BW3XL': { ancho: 65, alto: 200, fondo: 50 }, // 4 equipos de esquí
    }
    return dims[type] || null
  }

  getLockerUseCase(type) {
    // Baqueira typology texts (provided by Baqueira). Ski lockers are "taquillas";
    // STANDARD / MEDIUM are "consignas" — the heading follows that wording.
    const BAQUEIRA_TYPOLOGY = {
      'BN3XL': {
        heading: '¿Qué cabe en esta taquilla?',
        label: '2 Equipos de esquí',
        desc: 'Taquilla para 2 equipos completos de esquí. Cada equipo incluye 1 par de esquís, 1 par de botas, 1 casco y 1 juego de bastones.',
        fits: ['🎿 2 pares de esquís', '🥾 2 pares de botas', '🪖 2 cascos', '🏒 2 juegos de bastones'],
      },
      'CN3XL': {
        heading: '¿Qué cabe en esta taquilla?',
        label: '3 Equipos de esquí',
        desc: 'Taquilla para 3 equipos completos de esquí. Cada equipo incluye 1 par de esquís, 1 par de botas, 1 casco y 1 juego de bastones.',
        fits: ['🎿 3 pares de esquís', '🥾 3 pares de botas', '🪖 3 cascos', '🏒 3 juegos de bastones'],
      },
      'CW3XL': {
        heading: '¿Qué cabe en esta taquilla?',
        label: '3 Equipos de esquí (no incluye secado de botas)',
        desc: 'Taquilla para 3 equipos de esquí. Cada equipo incluye 1 par de esquís, 1 par de botas y 1 juego de bastones (no incluye espacio para casco).',
        fits: ['🎿 3 pares de esquís', '🥾 3 pares de botas', '🏒 3 juegos de bastones'],
      },
      'BW3XL': {
        heading: '¿Qué cabe en esta taquilla?',
        label: '4 Equipos de esquí',
        desc: 'Taquilla para 4 equipos completos de esquí. Cada equipo incluye 1 par de esquís, 1 par de botas, 1 casco y 1 juego de bastones.',
        fits: ['🎿 4 pares de esquís', '🥾 4 pares de botas', '🪖 4 cascos', '🏒 4 juegos de bastones'],
      },
      // STANDARD (30 × 30 × 50) — with and without charging
      'BNS': {
        heading: '¿Qué cabe en esta consigna?',
        label: 'Artículos pequeños',
        desc: 'Consigna para mochila o bolso pequeño y artículos personales de bolsillo.',
        fits: ['🎒 Mochila pequeña', '👜 Bolso pequeño', '📱 Artículos de bolsillo'],
      },
      // MEDIUM (30 × 60 × 50) — with and without charging
      'BNM': {
        heading: '¿Qué cabe en esta consigna?',
        label: 'Artículos de mayor tamaño',
        desc: 'Consigna para mochila grande.',
        fits: ['🎒 Mochila grande'],
      },
    }
    BAQUEIRA_TYPOLOGY.CNS = BAQUEIRA_TYPOLOGY.BNS
    BAQUEIRA_TYPOLOGY.CNM = BAQUEIRA_TYPOLOGY.BNM
    if (BAQUEIRA_TYPOLOGY[type]) return BAQUEIRA_TYPOLOGY[type]

    const d = this.getLockerDimensions(type)
    if (!d) return null
    const { ancho, alto } = d
    const wide = ancho >= 40
    if (alto <= 30) return { label: wide ? 'Artículos compactos y anchos' : 'Artículos pequeños', desc: wide ? 'Diseñada para cascos de bici o moto, bolsos de mano anchos y artículos personales voluminosos.' : 'Ideal para cascos de bicicleta, bolsos pequeños y artículos personales de bolsillo.', fits: wide ? ['🪖 Casco bici / moto', '👜 Bolso de mano', '📦 Artículos pequeños'] : ['🪖 Casco bicicleta', '👜 Bolso pequeño', '🎒 Mochila mini'] }
    if (alto <= 60) return { label: wide ? 'Mochila urbana grande' : 'Mochila urbana', desc: wide ? 'Cabe una mochila de ciudad amplia, bolsa de la compra o bolso de hombro de gran tamaño.' : 'Perfecta para mochila de portátil, bolsa de tela o chaqueta doblada.', fits: wide ? ['🎒 Mochila urbana', '🛍️ Bolsa de compras', '👜 Bolso grande'] : ['🎒 Mochila portátil', '🧥 Chaqueta', '🛍️ Bolsa de tela'] }
    if (alto <= 90) return { label: wide ? 'Maleta de cabina y mochilas grandes' : 'Mochilas grandes y deporte', desc: wide ? 'Admite mochilas de gran tamaño y maletas de cabina estándar.' : 'Caben mochilas de trekking, bolsas de deporte y equipo de montaña.', fits: wide ? ['🧳 Maleta cabina', '🎒 Mochila grande', '⛷️ Botas de esquí'] : ['🎒 Mochila trekking', '🏋️ Bolsa de deporte', '🏕️ Equipo montaña'] }
    if (alto <= 120) return { label: wide ? 'Maleta mediana' : 'Equipaje alto y estrecho', desc: wide ? 'Perfecta para maletas medianas de cabina y bolsas de deporte de gran tamaño.' : 'Indicada para maletas delgadas en posición vertical o bolsas de esquí estrechas.', fits: wide ? ['🧳 Maleta mediana', '🏋️ Bolsa deporte XL', '🎿 Bolsa de esquí'] : ['🧳 Maleta delgada', '🎿 Esquís', '🏄 Tabla estrecha'] }
    if (alto <= 150) return { label: wide ? 'Maleta grande de facturación' : 'Maleta alta y deporte', desc: wide ? 'Para maletas grandes de facturación y equipos deportivos voluminosos.' : 'Para maletas altas y estrechas, bolsas de viaje largas o estuches de instrumentos.', fits: wide ? ['🧳 Maleta grande', '🎿 Equipo esquí', '🛹 Skateboard'] : ['🧳 Maleta alta', '🎸 Estuche instrumento', '🏋️ Equipo deportivo'] }
    return { label: 'Equipaje extra grande', desc: wide ? 'Nuestra taquilla más grande. Admite maletas enormes, tablas de surf, bolsas de ski o bicicletas plegadas.' : 'Para equipos de gran formato: esquís, tablas largas, instrumentos o maletas extra altas.', fits: wide ? ['🧳 Maleta XXL', '🏄 Tabla de surf', '🚲 Bici plegable', '🎿 Bolsa de ski'] : ['🎿 Esquís', '🏄 Tabla larga', '🎻 Instrumento largo', '🧳 Maleta extra alta'] }
  }

  isBeforeToday(date) {
    const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
    const d = new Date(date).toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
    return d < today
  }

  isToday(date) {
    const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
    const d = new Date(date).toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' })
    return d === today
  }

  isTodayBlocked() {
    const nowInSpain = new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' })
    return new Date(nowInSpain).getHours() >= 18
  }

  isCurrentMonthOrBefore(date) {
    const today = new Date()
    return date.getFullYear() <= today.getFullYear() && date.getMonth() <= today.getMonth()
  }

  renderLockerGrid(onSelect) {
    const { lockers, prices, selectedLockerType } = this.state
    const { t } = this.props

    if (!lockers || !prices) {
      return <div className="bq-spinner"><img src="/images/logo_baqueira.png" alt="Logo" /></div>
    }

    const cards = ORDERED_LOCKER_KEYS.filter(key => lockers[key])

    if (cards.length === 0) {
      return (
        <div className="bq-ls-sold-out" onClick={() => history.go(-1)}>
          <h5>{t('TAQUILLAS AGOTADAS')}</h5>
          <h6>{t('Haz click aquí para volver a selección de zonas')}</h6>
        </div>
      )
    }

    const fewCards = cards.length < 4

    return (
      <div className={`bq-ls-locker-grid${fewCards ? ' bq-ls-locker-grid-few' : ''}`}>
        {cards.map((key) => {
          const d = this.getLockerDimensions(key)
          return (
            <div
              key={key}
              className={`bq-ls-locker-card${selectedLockerType === key ? ' bq-ls-locker-card-selected' : ''}`}
              onClick={() => onSelect(key)}
            >
              <button
                className="bq-ls-locker-info-btn"
                onClick={(e) => { e.stopPropagation(); this.setState({ measureModal: true, measureType: key }) }}
                title={t('Ver información')}
              >
                <Info size={13} strokeWidth={2.5} />
              </button>
              <div className="bq-ls-locker-img-wrap">
                <img src={this.getLockerPicture(key)} alt={key} className="bq-ls-locker-img" />
              </div>
              <span className="bq-ls-locker-type">{this.getLockerType(key)}</span>
              {d && <span className="bq-ls-locker-dims">{d.ancho} × {d.alto} × {d.fondo} cm</span>}
            </div>
          )
        })}
      </div>
    )
  }

  renderMeasureModal() {
    const { t } = this.props
    const { measureModal, measureType } = this.state
    if (!measureModal || !measureType) return null

    const d = this.getLockerDimensions(measureType)
    const useCase = this.getLockerUseCase(measureType)
    const close = () => this.setState({ measureModal: false, measureType: null })

    return (
      <div className="bq-ls-modal-overlay" onClick={close}>
        <div className="bq-ls-modal bq-ls-info-modal" onClick={(e) => e.stopPropagation()}>
          <div className="bq-ls-info-hero">
            <button className="bq-ls-info-back" onClick={close}>
              <ChevronLeft size={18} strokeWidth={2.5} />
              {t('Volver')}
            </button>
            <img src={this.getLockerPicture(measureType)} alt={measureType} className="bq-ls-info-hero-img" />
            <h4 className="bq-ls-info-hero-title">{this.getLockerType(measureType)}</h4>
          </div>
          {d && (
            <div className="bq-ls-info-dims">
              <div className="bq-ls-info-dim-block">
                <span className="bq-ls-info-dim-value">{d.ancho}</span>
                <span className="bq-ls-info-dim-unit">cm</span>
                <span className="bq-ls-info-dim-label">{t('Ancho')}</span>
              </div>
              <div className="bq-ls-info-dim-sep">×</div>
              <div className="bq-ls-info-dim-block">
                <span className="bq-ls-info-dim-value">{d.alto}</span>
                <span className="bq-ls-info-dim-unit">cm</span>
                <span className="bq-ls-info-dim-label">{t('Alto')}</span>
              </div>
              <div className="bq-ls-info-dim-sep">×</div>
              <div className="bq-ls-info-dim-block">
                <span className="bq-ls-info-dim-value">{d.fondo}</span>
                <span className="bq-ls-info-dim-unit">cm</span>
                <span className="bq-ls-info-dim-label">{t('Fondo')}</span>
              </div>
            </div>
          )}
          {useCase && (
            <div className="bq-ls-info-usecase">
              <div className="bq-ls-info-usecase-header">
                <div className="bq-ls-info-usecase-icon">📦</div>
                <span className="bq-ls-info-usecase-heading">{t(useCase.heading || '¿Qué cabe en esta taquilla?')}</span>
              </div>
              <span className="bq-ls-info-usecase-label">{t(useCase.label)}</span>
              <p className="bq-ls-info-usecase-desc">{t(useCase.desc)}</p>
              <div className="bq-ls-info-fits">
                {useCase.fits.map((item, i) => <span key={i} className="bq-ls-info-fit-tag">{t(item)}</span>)}
              </div>
            </div>
          )}
          <div className="bq-ls-info-footer" />
        </div>
      </div>
    )
  }

  renderStepper(qty) {
    const { t } = this.props
    const { qrData } = this.props
    const btnStyle = qrData?.headerConfig?.buttonColor1 && qrData?.headerConfig?.buttonColor2
      ? { background: `linear-gradient(135deg, ${qrData.headerConfig.buttonColor1}, ${qrData.headerConfig.buttonColor2})`, color: qrData.headerConfig.buttonText || '#fff' }
      : {}
    const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n))
    return (
      <div className="bq-ls-stepper-wrap">
        <div className="bq-ls-stepper-label">{t('Selecciona cuántas taquillas necesitas')}</div>
        <div className="bq-ls-stepper">
          <button type="button" className="bq-ls-stepper-btn" disabled={qty <= 1}
            onClick={() => this.setState({ selectedQuantity: clamp(qty - 1, 1, 10), startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false, appliedRule: null })}>
            −
          </button>
          <div className="bq-ls-stepper-value" style={btnStyle}>{qty}</div>
          <button type="button" className="bq-ls-stepper-btn" disabled={qty >= 10}
            onClick={() => this.setState({ selectedQuantity: clamp(qty + 1, 1, 10), startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false, appliedRule: null })}>
            +
          </button>
        </div>
        <p style={{ textAlign: 'center', fontSize: '0.9rem', marginTop: 8 }}>
          {qty} {qty > 1 ? t('taquillas seleccionadas') : t('taquilla seleccionada')}
        </p>
      </div>
    )
  }

  renderUnifiedForm() {
    const { t } = this.props
    const { selectedLockerType, selectedQuantity, startDate, endDate, isDurationExceeded, totalAmount, appliedRule } = this.state

    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity)
    const canContinue = selectedLockerType && selectedQuantity && startDate && !isDurationExceeded

    return (
      <div className="bq-ls-form">
        <div className="bq-ls-uf-row">
          <button type="button" className="bq-ls-uf-btn" onClick={() => this.openModal('isTypeModalOpen')}>
            <span className="bq-ls-uf-label">{t('Tipo de taquilla')}</span>
            <span className="bq-ls-uf-output">
              {selectedLockerType ? this.getLockerType(selectedLockerType) : t('Selecciona...')}
            </span>
          </button>
        </div>

        <div className="bq-ls-uf-row">
          <button type="button" className="bq-ls-uf-btn" onClick={() => this.openModal('isQtyModalOpen')} disabled={!selectedLockerType}>
            <span className="bq-ls-uf-label">{t('Cantidad')}</span>
            <span className="bq-ls-uf-output">{qty} {qty === 1 ? t('taquilla') : t('taquillas')}</span>
          </button>
        </div>

        <div className="bq-ls-uf-row">
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="bq-ls-uf-btn" style={{ flex: 1 }}
              onClick={() => this.openModal('isDatesModalOpen')} disabled={!selectedLockerType}>
              <span className="bq-ls-uf-label">{t('Inicio')}</span>
              <span className="bq-ls-uf-output">{startDate ? startDate.toLocaleDateString() : t('DD/MM/YYYY')}</span>
            </button>
            <div style={{ width: 1, background: 'rgba(0,0,0,0.07)', margin: '8px 0' }} />
            <button type="button" className="bq-ls-uf-btn" style={{ flex: 1 }}
              onClick={() => this.openModal('isDatesModalOpen')} disabled={!selectedLockerType || !startDate}>
              <span className="bq-ls-uf-label">{t('Fin')}</span>
              <span className="bq-ls-uf-output">{endDate ? endDate.toLocaleDateString() : t('DD/MM/YYYY')}</span>
            </button>
          </div>
        </div>

        {this.state.errorMessage && (
          <p style={{ color: '#e63946', textAlign: 'center', fontSize: '0.85rem' }}>
            {t('LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.')}
          </p>
        )}

        {appliedRule && (
          <p className="bq-ls-discount-badge">
            {t('Descuento aplicado: {{discount}}% (desde los {{days}} días)', { discount: appliedRule.DiscountPercentage, days: appliedRule.MaxDays })}
          </p>
        )}

        <button
          className={`bq-ls-btn-continue${!canContinue || this.state.isLoading ? ' disabled' : ''}`}
          disabled={!canContinue || this.state.isLoading}
          onClick={this.handleContinue}
        >
          {this.state.isLoading
            ? <span className="bq-ls-btn-spinner" />
            : `${t('Continuar')} ${t('por')} ${totalAmount.toFixed(2)} ${currencySymbol()}`}
        </button>

        {this.renderUnifiedModals()}
      </div>
    )
  }

  renderUnifiedModals() {
    const { t } = this.props
    const { isTypeModalOpen, isQtyModalOpen, isDatesModalOpen, selectedQuantity, startDate, endDate, isDurationExceeded, appliedRule } = this.state
    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity)

    return (
      <>
        {isTypeModalOpen && (
          <div className="bq-ls-modal-overlay" onClick={() => this.closeModal('isTypeModalOpen')}>
            <div className="bq-ls-modal" onClick={e => e.stopPropagation()}>
              <div className="bq-ls-modal-header">
                <h5 className="bq-ls-text-dark text-center">{t('Selecciona el tipo de taquilla')}</h5>
              </div>
              <div className="bq-ls-modal-body">
                {this.renderLockerGrid(key => { this.selectLockerType(key); this.closeModal('isTypeModalOpen'); this.openModal('isQtyModalOpen') })}
              </div>
            </div>
          </div>
        )}

        {isQtyModalOpen && (
          <div className="bq-ls-modal-overlay" onClick={() => this.closeModal('isQtyModalOpen')}>
            <div className="bq-ls-modal" onClick={e => e.stopPropagation()}>
              <div className="bq-ls-modal-header">
                <h5 className="bq-ls-text-dark text-center">{t('Cantidad de taquillas')}</h5>
              </div>
              <div className="bq-ls-modal-body" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {this.renderStepper(qty)}
              </div>
              <div className="bq-ls-modal-footer">
                <button className="bq-ls-btn-continue" onClick={() => { this.closeModal('isQtyModalOpen'); this.openModal('isDatesModalOpen') }}>
                  {t('Confirmar')}
                </button>
              </div>
            </div>
          </div>
        )}

        {isDatesModalOpen && (
          <div className="bq-ls-modal-overlay" onClick={() => this.closeModal('isDatesModalOpen')}>
            <div className="bq-ls-modal" onClick={e => e.stopPropagation()}>
              <div className="bq-ls-modal-header">
                <h5 className="bq-ls-text-dark text-center">{t('Selecciona las fechas')}</h5>
              </div>
              <div className="bq-ls-modal-body" style={{ textAlign: 'center' }}>
                {this.renderPriceCalendar()}
                {isDurationExceeded && (
                  <p style={{ color: '#e63946', fontSize: '0.82rem', marginTop: 8 }}>
                    {t('El alquiler online está limitado a 30 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es')}
                  </p>
                )}
              </div>
              <div className="bq-ls-modal-footer">
                <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: 10 }}>
                  <div>
                    <div className="bq-ls-uf-label">{t('Inicio')}</div>
                    <span>{startDate ? startDate.toLocaleDateString() : t('DD/MM/YYYY')}</span>
                  </div>
                  <div>
                    <div className="bq-ls-uf-label">{t('Fin')}</div>
                    <span>{endDate ? endDate.toLocaleDateString() : t('DD/MM/YYYY')}</span>
                  </div>
                </div>
                {appliedRule && (
                  <p className="bq-ls-discount-badge" style={{ marginBottom: 8 }}>
                    {t('Descuento aplicado: {{discount}}% (desde los {{days}} días)', { discount: appliedRule.DiscountPercentage, days: appliedRule.MaxDays })}
                  </p>
                )}
                <button
                  className={`bq-ls-btn-continue${!startDate || isDurationExceeded ? ' disabled' : ''}`}
                  disabled={!startDate || isDurationExceeded}
                  onClick={() => this.closeModal('isDatesModalOpen')}
                >
                  {t('Confirmar')}
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  renderUnifiedFormPc() {
    const { t } = this.props
    const { selectedLockerType, selectedQuantity, startDate, endDate, isDurationExceeded, totalAmount, appliedRule } = this.state

    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity)
    const canContinue = selectedLockerType && selectedQuantity && startDate && !isDurationExceeded

    return (
      <>
        <div className="bq-ls-sel-form" ref={this.formRef}>
          <button ref={this.typeBtnRef} type="button" className="bq-ls-uf-btn" onClick={() => this.openPanel('type')}>
            <span className="bq-ls-uf-label">{t('Tipo')}</span>
            <span className="bq-ls-uf-output">{selectedLockerType ? this.getLockerType(selectedLockerType) : t('Selecciona...')}</span>
          </button>

          <button ref={this.qtyBtnRef} type="button" className="bq-ls-uf-btn" onClick={() => this.openPanel('qty')} disabled={!selectedLockerType}>
            <span className="bq-ls-uf-label">{t('Cantidad')}</span>
            <span className="bq-ls-uf-output">{qty} {qty === 1 ? t('taquilla') : t('taquillas')}</span>
          </button>

          <button ref={this.datesStartBtnRef} type="button" className="bq-ls-uf-btn" onClick={() => this.openPanel('dates')} disabled={!selectedLockerType}>
            <span className="bq-ls-uf-label">{t('Inicio')}</span>
            <span className="bq-ls-uf-output">{startDate ? startDate.toLocaleDateString() : t('DD/MM/YYYY')}</span>
          </button>

          <button type="button" className="bq-ls-uf-btn" onClick={() => this.openPanel('dates')} disabled={!selectedLockerType || !startDate}>
            <span className="bq-ls-uf-label">{t('Fin')}</span>
            <span className="bq-ls-uf-output">{endDate ? endDate.toLocaleDateString() : t('DD/MM/YYYY')}</span>
          </button>

          {appliedRule && (
            <span className="bq-ls-discount-badge">
              -{appliedRule.DiscountPercentage}%
            </span>
          )}

          <button
            className={`bq-ls-btn-continue${!canContinue || this.state.isLoading ? ' disabled' : ''}`}
            disabled={!canContinue || this.state.isLoading}
            onClick={this.handleContinue}
          >
            {this.state.isLoading
              ? <span className="bq-ls-btn-spinner" />
              : `${t('Continuar')} — ${totalAmount.toFixed(2)} ${currencySymbol()}`}
          </button>
        </div>

        {this.state.errorMessage && (
          <p style={{ color: '#e63946', textAlign: 'center', fontSize: '0.85rem' }}>
            {t('LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.')}
          </p>
        )}

        {this.renderUnifiedPanels()}
      </>
    )
  }

  renderUnifiedPanels() {
    const { t } = this.props
    const { activePanel, selectedQuantity, startDate, endDate, isDurationExceeded, appliedRule } = this.state
    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity)

    return (
      <>
        {activePanel === 'type' && (
          <div className="bq-ls-uf-panel show">
            <h5 className="bq-ls-text-dark text-center mb-3">{t('Selecciona el tipo de taquilla')}</h5>
            {this.renderLockerGrid(key => { this.selectLockerType(key); this.openPanel('qty') })}
          </div>
        )}

        {activePanel === 'qty' && (
          <div className="bq-ls-uf-panel text-center show">
            <h5 className="bq-ls-text-dark text-center mb-3">{t('Cantidad de taquillas')}</h5>
            {this.renderStepper(qty)}
          </div>
        )}

        {activePanel === 'dates' && (
          <div className="bq-ls-uf-panel text-center show">
            <h5 className="bq-ls-text-dark text-center mb-3">{t('Selecciona las fechas')}</h5>
            <div style={{ height: 1, background: 'rgba(0,0,0,0.07)', margin: '0 0 16px' }} />
            {isDurationExceeded && (
              <p style={{ color: '#e63946', fontSize: '0.82rem' }}>
                {t('El alquiler online está limitado a 30 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es')}
              </p>
            )}
            {this.renderPriceCalendarPC()}
            {appliedRule && (
              <p className="bq-ls-discount-badge" style={{ marginTop: 8 }}>
                {t('Descuento aplicado: {{discount}}% (desde los {{days}} días)', { discount: appliedRule.DiscountPercentage, days: appliedRule.MaxDays })}
              </p>
            )}
          </div>
        )}
      </>
    )
  }

  render() {
    const { t } = this.props
    const { lockers, prices } = this.state
    const { zoneSelected, descriptionZone } = this.props.location.state

    if (!lockers || !prices) {
      return (
        <div className="baqueiraBackground">
          <AppBaqueiraHeader />
          <div className="nm-page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="bq-spinner">
              <img src="/images/logo_baqueira.png" alt="Logo" />
            </div>
          </div>
          <StepBarBaqueira step={2} />
        </div>
      )
    }

    const headerCard = (
      <div className="bq-ls-header-card">
        <div className="bq-ls-header-card-text">
          <h3>{t('RESERVA DE TAQUILLA')}</h3>
          <span className="bq-ls-header-zone">{zoneSelected} — {descriptionZone}</span>
        </div>
        <Grid2x2Check className="bq-ls-form-icon" strokeWidth={1} />
      </div>
    )

    return (
      <div className="baqueiraBackground">
        <AppBaqueiraHeader />
        <StepBarBaqueira step={2} />

        <div className="nm-page d-xl-none">
          {headerCard}
          {this.renderUnifiedForm()}
        </div>

        <div className="nm-page pc d-none d-xl-block">
          {headerCard}
          {this.renderUnifiedFormPc()}
        </div>

        {this.renderMeasureModal()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  lockers: state.lockers,
  prices: state.prices,
  qrData: state.qrs.qr,
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchDisponibility: bindActionCreators(fetchDisponibility, dispatch),
  fetchAvailability: bindActionCreators(fetchAvailability, dispatch),
  fetchCalendarByOperator: bindActionCreators(fetchCalendarByOperator, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(LockerSelectorBaqueiraView))
